<div class="dashboard">

  <!-- KPI CARDS -->
  <div class="kpi-grid">
    <div class="kpi-card">
      <div class="kpi-icon blue"><i class="fa fa-bolt"></i></div>
      <div class="kpi-content">
        <div class="kpi-value">
          {{ formatNumber(reportIndicators?.Table?.[0]?.AvgPowerFactor) }}
        </div>
        <div class="kpi-label">میانگین ضریب توان (PF)</div>
      </div>
    </div>
    <div class="kpi-card">
      <div class="kpi-icon green"><i class="fa fa-bar-chart"></i></div>
      <div class="kpi-content">
        <div class="kpi-value">
          {{ formatNumber(reportIndicators?.Table?.[0]?.AvgLoadPercentage) }}
        </div>
        <div class="kpi-label">میانگین درصد بار (%)</div>
      </div>
    </div>
    <div class="kpi-card">
      <div class="kpi-icon orange"><i class="fa fa-cogs"></i></div>
      <div class="kpi-content">
        <div class="kpi-value">
          {{
            formatNumber(reportIndicators?.Table?.[0]?.AvgGeneratorEfficiency)
          }}
        </div>
        <div class="kpi-label">میانگین راندمان ژنراتور (%)</div>
      </div>
    </div>
    <div class="kpi-card">
      <div class="kpi-icon purple"><i class="fa fa-heartbeat"></i></div>
      <div class="kpi-content">
        <div class="kpi-value">
          {{ formatNumber(reportIndicators?.Table?.[0]?.AvgPhaseHealth, 0) }}
        </div>
        <div class="kpi-label">میانگین سلامت فازها</div>
      </div>
    </div>
    <div class="kpi-card">
      <div class="kpi-icon red"><i class="fa fa-plug"></i></div>
      <div class="kpi-content">
        <div class="kpi-value">
          {{
            formatNumber(reportIndicators?.Table?.[0]?.AvgElectricalHealth, 0)
          }}
        </div>
        <div class="kpi-label">میانگین سلامت سیستم برق</div>
      </div>
    </div>
    <div class="kpi-card">
      <div class="kpi-icon yellow"><i class="fa fa-server"></i></div>
      <div class="kpi-content">
        <div class="kpi-value">
          {{ reportIndicators?.Table?.[0]?.TotalOnlineGenerators ?? "--" }}
        </div>
        <div class="kpi-label">تعداد دیزل‌های آنلاین</div>
      </div>
    </div>
  </div>

  <!-- CHARTS -->
  <div class="charts-grid">
    <div class="chart-card">
      <h3><i class="fa fa-chart-pie"></i> توزیع درصد بار دستگاه‌ها</h3>
      <div class="chart-wrapper"><canvas #distributionChart></canvas></div>
    </div>
    <div class="chart-card">
      <h3><i class="fa fa-heart"></i> مقایسه امتیاز سلامت (۱۰ دستگاه برتر)</h3>
      <div class="chart-wrapper"><canvas #healthChart></canvas></div>
    </div>
    <div class="chart-card">
      <h3><i class="fa fa-bolt"></i> ضریب توان (۱۰ دستگاه برتر)</h3>
      <div class="chart-wrapper"><canvas #pfChart></canvas></div>
    </div>
    <div class="chart-card">
      <h3><i class="fa fa-cog"></i> راندمان ژنراتور (۱۰ دستگاه برتر)</h3>
      <div class="chart-wrapper"><canvas #efficiencyChart></canvas></div>
    </div>
  </div>

  <!-- FOOTER -->
  <div class="footer">
    LoadWatch · شاخص‌های عملکرد ناوگان · به‌روزرسانی خودکار هر ۳۰ ثانیه
  </div>
</div>
